import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InitiateCoordination() {
  return <section data-section-id="246496" id="cosre-fatte" className="bg-muted text-foreground relative overflow-hidden py-24 lg:py-32 border-t border-border/50 border-b">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_city_hall_texture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_city_hall_texture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/albano_city_hall_texture.png-wvc-sizes" alt="Albano Laziale istituzionale" className="absolute inset-0 w-full h-full object-cover opacity-5 mix-blend-multiply pointer-events-none" loading="lazy" decoding="async" />

      {}
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-primary/5 rounded-lg blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-secondary/10 rounded-lg blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-default font-bold tracking-tight mb-12 text-primary">
            Le promesse diventano fatti
          </h2>

          <p className="text-base md:text-lg lg:text-xl font-default text-muted-foreground mb-12 max-w-2xl mx-auto">
            Dal 2020 al 2025 abbiamo lavorato con dedizione per trasformare la visione di Albano in realtà concrete, portando a termine i progetti promessi ai cittadini.
          </p>

          {}
          <div className="relative group mb-16 mx-auto w-full max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-3xl aspect-video rounded-lg overflow-hidden shadow-2xl border border-border/50 bg-black">
            <video src="https://borellisindaco.it/wp-content/uploads/2026/05/FDownloader.Net_AQOaFBcYu7N1ae57aCoo9bi4TX8Sxmsoew3jXsFkXgYWhZ7oi-nSzTbc5fTi_EQN35jiSi8Kov37B5Y5-C5qZe7jEexcCrMQR-8iqpxBvKvuPA_720p_HD.mp4" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659171/img/video_placeholder.png" controls className="w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700">
              Il tuo browser non supporta il tag video.
            </video>
            <div className="absolute inset-0 flex items-center justify-center bg-primary/20 group-hover:bg-primary/10 transition-colors duration-300 pointer-events-none">
              <div className="size-20 md:size-24 bg-secondary text-secondary-foreground rounded-lg flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform duration-300">
                <Play className="size-8 md:size-10 fill-current ml-1" />
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-linear-to-t from-black/80 to-transparent text-left pointer-events-none">
              <p className="text-white font-bold text-lg md:text-xl">Albano 2020-2025: I traguardi raggiunti</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button size="lg" className="w-full sm:w-auto text-base h-12 px-6 md:text-lg md:h-16 md:px-10 shadow-md bg-primary hover:bg-primary/90 text-primary-foreground" asChild>
              <Link to="https://borellisindaco.it/video/">
                Guarda i risultati
                <ArrowRight className="ml-2 size-6" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-lg h-16 px-10 border-primary/20 hover:bg-primary/5 text-primary font-medium" asChild>
              <Link to="/AboutMePage">La mia storia</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}